import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseApiService } from '../shared/base-service/base-api.service';

@Injectable()
export class NoteManageService extends BaseApiService {
    getNotes(noteIdentificationValue: string, noteIdentificationTypeId: string) {
        return this.get('Note/Note/History/' + noteIdentificationValue + '/' + noteIdentificationTypeId);
    }

    isVehicleOwnershipHasOIGFraudNote(noteIdentificationValue: number) {
        return this.get('Note/Note/IsVehicleOwnershipHasOIGFraudNote/' + noteIdentificationValue);
    }

    getHistoryNotes(noteId: number) {
        return this.get('Note/Note/History/' + noteId);
    }

    getNoteChildren(noteId: string) {
        return this.get('Note/Note/' + noteId + '/Children');
    }

    saveNote(NoteViewModel) {
        return this.post('Note/Note/SaveNote', NoteViewModel, this.replacer).pipe(
            catchError(
                (error) => this.handleError(error)
            ));
    }

    saveCustomerNote(NoteViewModel) {
        return this.post('Note/Note/SaveCustomerNote', NoteViewModel, this.replacer).pipe(
            catchError(
                (error) => this.handleError(error)
            ));
    }

    deleteNote(noteId: string) {
        return this.delete('Note/Note/DeleteNote/' + noteId).pipe(
            catchError(
                (error) => this.handleError(error)
            ));
    }

    getOIGNotes(searchCriteria: any) {
        return this.post('Note/Note/GetOIGNotes', searchCriteria);
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            var errorObject = {
                httpStatus: error.status,
                response: error.error
            };
            return observableThrowError(errorObject);
        } else {
            return observableThrowError('Server error');
        }
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }

        return value;
    }
}
